import React, { useEffect, useMemo, useState } from "react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import PageIntro from "../components/PageIntro";
import heroGallery from "../assets/heroes/hero-gallery.webp";

import studioImage01 from "../assets/studio-images/studio-image01.webp";
import studioImage02 from "../assets/studio-images/studio-image02.webp";
import studioImage03 from "../assets/studio-images/studio-image03.webp";
import studioImage04 from "../assets/studio-images/studio-image04.webp";
import studioImage05 from "../assets/studio-images/studio-image05.webp";
import studioImage06 from "../assets/studio-images/studio-image06.webp";
import studioImage07 from "../assets/studio-images/studio-image07.webp";
import studioImage08 from "../assets/studio-images/studio-image08.webp";
import studioImage09 from "../assets/studio-images/studio-image09.webp";
import studioImage10 from "../assets/studio-images/studio-image10.webp";
import studioImage11 from "../assets/studio-images/studio-image11.webp";
import studioImage12 from "../assets/studio-images/studio-image12.webp";
import studioImage13 from "../assets/studio-images/studio-image13.webp";
import studioImage14 from "../assets/studio-images/studio-image14.webp";
import studioImage15 from "../assets/studio-images/studio-image15.webp";
import studioImage16 from "../assets/studio-images/studio-image16.webp";
import studioImage17 from "../assets/studio-images/studio-image17.webp";
import studioImage18 from "../assets/studio-images/studio-image18.webp";
import studioImage19 from "../assets/studio-images/studio-image19.webp";
import studioImage20 from "../assets/studio-images/studio-image20.webp";
import studioImage21 from "../assets/studio-images/studio-image21.webp";
import studioImage22 from "../assets/studio-images/studio-image22.webp";
import studioImage23 from "../assets/studio-images/studio-image23.webp";
import studioImage24 from "../assets/studio-images/studio-image24.webp";
import studioImage25 from "../assets/studio-images/studio-image25.webp";
import studioImage26 from "../assets/studio-images/studio-image26.webp";
import studioImage27 from "../assets/studio-images/studio-image27.webp";
import studioImage28 from "../assets/studio-images/studio-image28.webp";
import studioImage29 from "../assets/studio-images/studio-image29.webp";
import studioImage30 from "../assets/studio-images/studio-image30.webp";
import studioImage31 from "../assets/studio-images/studio-image31.webp";
import studioImage32 from "../assets/studio-images/studio-image32.webp";
import studioImage33 from "../assets/studio-images/studio-image33.webp";
import studioImage34 from "../assets/studio-images/studio-image34.webp";
import studioImage35 from "../assets/studio-images/studio-image35.webp";
import studioImage36 from "../assets/studio-images/studio-image36.webp";
import studioImage37 from "../assets/studio-images/studio-image37.webp";
import studioImage38 from "../assets/studio-images/studio-image38.webp";
import studioImage39 from "../assets/studio-images/studio-image39.webp";
import studioImage40 from "../assets/studio-images/studio-image40.webp";
import studioImage41 from "../assets/studio-images/studio-image41.webp";
import studioThumb01 from "../assets/studio-thumbs/studio-thumb01.webp";
import studioThumb02 from "../assets/studio-thumbs/studio-thumb02.webp";
import studioThumb03 from "../assets/studio-thumbs/studio-thumb03.webp";
import studioThumb04 from "../assets/studio-thumbs/studio-thumb04.webp";
import studioThumb05 from "../assets/studio-thumbs/studio-thumb05.webp";
import studioThumb06 from "../assets/studio-thumbs/studio-thumb06.webp";
import studioThumb07 from "../assets/studio-thumbs/studio-thumb07.webp";
import studioThumb08 from "../assets/studio-thumbs/studio-thumb08.webp";
import studioThumb09 from "../assets/studio-thumbs/studio-thumb09.webp";
import studioThumb10 from "../assets/studio-thumbs/studio-thumb10.webp";
import studioThumb11 from "../assets/studio-thumbs/studio-thumb11.webp";
import studioThumb12 from "../assets/studio-thumbs/studio-thumb12.webp";
import studioThumb13 from "../assets/studio-thumbs/studio-thumb13.webp";
import studioThumb14 from "../assets/studio-thumbs/studio-thumb14.webp";
import studioThumb15 from "../assets/studio-thumbs/studio-thumb15.webp";
import studioThumb16 from "../assets/studio-thumbs/studio-thumb16.webp";
import studioThumb17 from "../assets/studio-thumbs/studio-thumb17.webp";
import studioThumb18 from "../assets/studio-thumbs/studio-thumb18.webp";
import studioThumb19 from "../assets/studio-thumbs/studio-thumb19.webp";
import studioThumb20 from "../assets/studio-thumbs/studio-thumb20.webp";
import studioThumb21 from "../assets/studio-thumbs/studio-thumb21.webp";
import studioThumb22 from "../assets/studio-thumbs/studio-thumb22.webp";
import studioThumb23 from "../assets/studio-thumbs/studio-thumb23.webp";
import studioThumb24 from "../assets/studio-thumbs/studio-thumb24.webp";
import studioThumb25 from "../assets/studio-thumbs/studio-thumb25.webp";
import studioThumb26 from "../assets/studio-thumbs/studio-thumb26.webp";
import studioThumb27 from "../assets/studio-thumbs/studio-thumb27.webp";
import studioThumb28 from "../assets/studio-thumbs/studio-thumb28.webp";
import studioThumb29 from "../assets/studio-thumbs/studio-thumb29.webp";
import studioThumb30 from "../assets/studio-thumbs/studio-thumb30.webp";
import studioThumb31 from "../assets/studio-thumbs/studio-thumb31.webp";
import studioThumb32 from "../assets/studio-thumbs/studio-thumb32.webp";
import studioThumb33 from "../assets/studio-thumbs/studio-thumb33.webp";
import studioThumb34 from "../assets/studio-thumbs/studio-thumb34.webp";
import studioThumb35 from "../assets/studio-thumbs/studio-thumb35.webp";
import studioThumb36 from "../assets/studio-thumbs/studio-thumb36.webp";
import studioThumb37 from "../assets/studio-thumbs/studio-thumb37.webp";
import studioThumb38 from "../assets/studio-thumbs/studio-thumb38.webp";
import studioThumb39 from "../assets/studio-thumbs/studio-thumb39.webp";
import studioThumb40 from "../assets/studio-thumbs/studio-thumb40.webp";
import studioThumb41 from "../assets/studio-thumbs/studio-thumb41.webp";
import CtaBand from "../components/CtaBand";
import ctaStudio from "../assets/heroes/cta-studio.webp";
import { PAGES } from "../seoContent";
import { studioImageAlt } from "../studioImageAlts";

const STUDIO_IMAGES = [
  studioImage01,
  studioImage02,
  studioImage03,
  studioImage04,
  studioImage05,
  studioImage06,
  studioImage07,
  studioImage08,
  studioImage09,
  studioImage10,
  studioImage11,
  studioImage12,
  studioImage13,
  studioImage14,
  studioImage15,
  studioImage16,
  studioImage17,
  studioImage18,
  studioImage19,
  studioImage20,
  studioImage21,
  studioImage22,
  studioImage23,
  studioImage24,
  studioImage25,
  studioImage26,
  studioImage27,
  studioImage28,
  studioImage29,
  studioImage30,
  studioImage31,
  studioImage32,
  studioImage33,
  studioImage34,
  studioImage35,
  studioImage36,
  studioImage37,
  studioImage38,
  studioImage39,
  studioImage40,
  studioImage41,
];

const STUDIO_THUMBS = [
  studioThumb01,
  studioThumb02,
  studioThumb03,
  studioThumb04,
  studioThumb05,
  studioThumb06,
  studioThumb07,
  studioThumb08,
  studioThumb09,
  studioThumb10,
  studioThumb11,
  studioThumb12,
  studioThumb13,
  studioThumb14,
  studioThumb15,
  studioThumb16,
  studioThumb17,
  studioThumb18,
  studioThumb19,
  studioThumb20,
  studioThumb21,
  studioThumb22,
  studioThumb23,
  studioThumb24,
  studioThumb25,
  studioThumb26,
  studioThumb27,
  studioThumb28,
  studioThumb29,
  studioThumb30,
  studioThumb31,
  studioThumb32,
  studioThumb33,
  studioThumb34,
  studioThumb35,
  studioThumb36,
  studioThumb37,
  studioThumb38,
  studioThumb39,
  studioThumb40,
  studioThumb41,
];

// Natural width and height of each studio photo, used to reserve space before it loads.
const STUDIO_RATIOS = [
  [1638, 2047],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1638, 2047],
  [1638, 2048],
  [1368, 2049],
  [1368, 2049],
  [1368, 2049],
  [2048, 1367],
  [1638, 2047],
  [1638, 2047],
  [1638, 2047],
  [1640, 2049],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1462, 2046],
  [1638, 2047],
  [1638, 2047],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1638, 2047],
  [1638, 2047],
  [1638, 2047],
  [1638, 2048],
  [2048, 1367],
  [2048, 1462],
  [1638, 2047],
  [1368, 2049],
  [1638, 2047],
  [1638, 2047],
  [1368, 2049],
];

// const EVENT_IMAGES = [

// ];

const TABS = [
  {
    id: "studio",
    label: "Studio",
    title: "Studio Gallery",
    description: "Browse moments captured during our studio sessions.",
    images: STUDIO_IMAGES,
    thumbs: STUDIO_THUMBS,
    ratios: STUDIO_RATIOS,
  },
  //   {
  //     id: "events",
  //     label: "Events",
  //     title: "Events Gallery",
  //     description: "Event highlights will appear here once added.",
  //     images: EVENT_IMAGES,
  //   },
];

function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  if (!images.length) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1c1c1c]/95 p-4">
      <button
        type="button"
        onClick={onClose}
        aria-label="Close preview"
        className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
      >
        ✕
      </button>

      {images.length > 1 && (
        <button
          type="button"
          onClick={onPrev}
          aria-label="Previous image"
          className="absolute left-4 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
        >
          ‹
        </button>
      )}

      <img
        src={images[currentIndex]}
        alt={studioImageAlt(currentIndex)}
        className="max-h-[85vh] max-w-full rounded-2xl object-contain shadow-2xl"
      />

      {images.length > 1 && (
        <button
          type="button"
          onClick={onNext}
          aria-label="Next image"
          className="absolute right-4 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
        >
          ›
        </button>
      )}

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-white/80">
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  );
}

export default function Gallery() {
  const [activeTab, setActiveTab] = useState("studio");
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const activeSection = useMemo(
    () => TABS.find((tab) => tab.id === activeTab) || TABS[0],
    [activeTab],
  );

  const openLightbox = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxImages([]);
    setLightboxIndex(0);
  };

  const showPrev = () => {
    setLightboxIndex((prev) =>
      prev === 0 ? lightboxImages.length - 1 : prev - 1,
    );
  };

  const showNext = () => {
    setLightboxIndex((prev) => (prev + 1) % lightboxImages.length);
  };

  useEffect(() => {
    const total = lightboxImages.length;
    if (!total) return undefined;

    const onKey = (e) => {
      if (e.key === "Escape") {
        setLightboxImages([]);
        setLightboxIndex(0);
      } else if (e.key === "ArrowLeft") {
        setLightboxIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
      } else if (e.key === "ArrowRight") {
        setLightboxIndex((prev) => (prev + 1) % total);
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightboxImages]);

  return (
    <>
      <SEO
        title={PAGES["/gallery"].title}
        description={PAGES["/gallery"].description}
      />

      <main className="min-h-screen bg-white text-black">
        <PageHero
          title="Gallery"
          image={heroGallery}
          imagePosition="center 25%"
        />

        <PageIntro>
          A selection of studio portraits, family sessions and maternity shoots captured at our Rochdale studio. Click any photo to view it full size.
        </PageIntro>

        {TABS.length > 1 && (
          <section className="sticky top-0 z-30 border-b border-black/10 bg-white/90 backdrop-blur">
            <div className="mx-auto max-w-7xl px-6 py-4 sm:px-10 lg:px-16 xl:px-6">
              <div className="inline-flex rounded-full border border-black/10 bg-white p-1 shadow-sm">
                {TABS.map((tab) => {
                  const active = activeTab === tab.id;

                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      className={[
                        "rounded-full px-5 py-2.5 text-sm font-medium transition",
                        active
                          ? "bg-pink-500 text-white"
                          : "text-black/60 hover:bg-black/5 hover:text-black",
                      ].join(" ")}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </section>
        )}

        <section className="bg-[#fff7fb]">
          <div className="mx-auto max-w-7xl px-6 py-14 sm:px-10 md:py-16 lg:px-16 xl:px-6">
            <div className="mb-10 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <h2 className="text-3xl font-semibold">
                  {activeSection.title}
                </h2>
                <p className="mt-3 max-w-2xl text-black/60">
                  {activeSection.description}
                </p>
              </div>

              <div className="w-fit rounded-full border border-black/10 bg-white px-4 py-2 text-sm text-black/60">
                {activeSection.images.length} image
                {activeSection.images.length !== 1 ? "s" : ""}
              </div>
            </div>

            {activeSection.images.length === 0 ? (
              <div className="rounded-[2rem] border border-dashed border-black/15 bg-white px-6 py-14 text-center text-black/50">
                No images here yet. Event photos will appear in this tab later.
              </div>
            ) : (
              <div className="columns-2 gap-4 sm:columns-3 lg:columns-4">
                {activeSection.images.map((img, index) => (
                  <button
                    key={`${activeSection.id}-${index}`}
                    type="button"
                    onClick={() => openLightbox(activeSection.images, index)}
                    aria-label={`Open photo ${index + 1}`}
                    className="group relative mb-4 block w-full break-inside-avoid overflow-hidden rounded-2xl border border-black/10 bg-white text-left shadow-[0_10px_30px_rgba(0,0,0,0.06)] transition hover:shadow-[0_18px_44px_rgba(0,0,0,0.14)]"
                  >
                    <img
                      src={activeSection.thumbs?.[index] || img}
                      alt={studioImageAlt(index)}
                      width={activeSection.ratios?.[index]?.[0]}
                      height={activeSection.ratios?.[index]?.[1]}
                      loading="lazy"
                      decoding="async"
                      className="block h-auto w-full bg-black/5 transition duration-500 group-hover:scale-105"
                    />
                    <span className="pointer-events-none absolute inset-0 bg-[#1c1c1c]/0 transition duration-300 group-hover:bg-[#1c1c1c]/25" />
                  </button>
                ))}
              </div>
            )}
          </div>
        </section>

        <section className="bg-white">
          <div className="mx-auto max-w-7xl px-6 py-14 sm:px-10 lg:px-16 xl:px-6">
            <CtaBand
              heading="Book Your Studio Photoshoot in Rochdale"
              text="Choose a session, pick a time and get portraits, family and maternity photos you will love."
              to="/book"
              label="Book a Session"
              image={ctaStudio}
            />
          </div>
        </section>
      </main>

      <Lightbox
        images={lightboxImages}
        currentIndex={lightboxIndex}
        onClose={closeLightbox}
        onPrev={showPrev}
        onNext={showNext}
      />
    </>
  );
}
